export default __webpack_public_path__ + "e2d33e3d4cd854e7c78949a70b5f01b7.png";